import { DOMUtils } from '../../../../../utils/dom'

export class ShowPasswordButton {
    private static DOM = {
        class: {
            button: 'button',
            buttonText: 'button__text',
            buttonWrapper: 'show-password-button-container',
            showPasswordVisible: 'show-password--visible'
        }
    }

    public static async initDOM() {
        const passwordFields = document.querySelectorAll('[type=password]')

        if (passwordFields) {
            const mod = await import('../templates/show-password-button/show-password-button.htm')
            const showPasswordButton = mod.default
            passwordFields.forEach((passwordField) => {
                const buttonWrapper = document.createElement('div') as HTMLElement
                DOMUtils.addClass(buttonWrapper, ShowPasswordButton.DOM.class.buttonWrapper)
                buttonWrapper.innerHTML = showPasswordButton
                passwordField.after(buttonWrapper)

                ShowPasswordButton.addListeners(passwordField as HTMLInputElement, buttonWrapper)
            })
        }
    }

    private static addListeners(passwordField: HTMLInputElement, buttonWrapper: HTMLElement) {
        const button = buttonWrapper.querySelector(`.${ShowPasswordButton.DOM.class.button}`)
        const buttonText = buttonWrapper.querySelector(`.${ShowPasswordButton.DOM.class.buttonText}`)

        if (button && buttonText) {
            button.addEventListener('click', () => {
                if (passwordField.type === 'password') {
                    passwordField.type = 'input'
                    buttonText.innerHTML = 'Hide'
                    DOMUtils.addClass(buttonWrapper, ShowPasswordButton.DOM.class.showPasswordVisible)
                } else {
                    passwordField.type = 'password'
                    buttonText.innerHTML = 'Show'
                    DOMUtils.removeClass(buttonWrapper, ShowPasswordButton.DOM.class.showPasswordVisible)
                }
                passwordField.focus()
            })
        }
    }
}
